import React from 'react';
import Plot from 'react-plotly.js';

const ChartComponent = ({ correctData, incorrectData }) => {
  const countCorrectMap = new Map();
  for (const [word, length] of Object.entries(correctData)) {
      if (length) {
      const key = length.toString();
      if (!countCorrectMap.has(key)) {
        countCorrectMap.set(key, { count: 0, words: [] });
      }
      countCorrectMap.get(key).count += 1;
      countCorrectMap.get(key).words.push(word);
    }
  }

  const x1 = [];
  const y1 = [];
  const text1 = [];

  for (const [count, { count: occurrences, words }] of countCorrectMap) {
    x1.push(parseInt(count));
    y1.push(occurrences);
    text1.push(words.join('-'));
  }

  const countIncorrectMap = new Map();
  for (const [word, length] of Object.entries(incorrectData)) {
    if (length) {
      const key = length.toString();
      if (!countIncorrectMap.has(key)) {
        countIncorrectMap.set(key, { count: 0, words: [] });
      }
      countIncorrectMap.get(key).count += 1;
      countIncorrectMap.get(key).words.push(word);
    }
  }

  const x2 = [];
  const y2 = [];
  const text2 = [];

  for (const [count, { count: occurrences, words }] of countIncorrectMap) {
    x2.push(parseInt(count));
    y2.push(occurrences);
    text2.push(words.join('-'));
  }

  // const correctWords = Object.keys(correctData);
  // const correctOccurrences = Object.values(correctData);

  // const incorrectWords = Object.keys(incorrectData);
  // const incorrectOccurrences = Object.values(incorrectData);

  // const data = [
  //   {
  //     type: 'bar',
  //     x: correctWords,
  //     y: correctOccurrences,
  //     name: 'Correct Words',
  //     marker: { color: 'green' },
  //   },
  //   {
  //     type: 'bar',
  //     x: incorrectWords,
  //     y: incorrectOccurrences,
  //     name: 'Incorrect Words',
  //     marker: { color: 'red' },
  //   },
  // ];

  // const layout = {
  //   title: 'Word Occurrences Chart',
  //   barmode: 'group',
  //   xaxis: { title: 'Words' },
  //   yaxis: { title: 'Occurrences' },
  // };

  const trace1 = {
    x: x1,
    y: y1,
    mode: 'markers',
    type: 'scatter',
    name: 'Mots corrects',
    text: text1,
    marker: { size: 12, color: '#555' }
  };
  
  const trace2 = {
    x: x2,
    y: y2,
    mode: 'markers',
    type: 'scatter',
    name: 'Mots cibles',
    text: text2,
    marker: { size: 12, color: 'green' }
  };
  
  const data = [ trace1, trace2 ];
  
  const layout = {
    title:'Répartition des mots corrects et des mots cibles.',
    xaxis: {
      title: 'Propriété sélectionnée',
    },
    yaxis: {
      title: 'Nombre de mots',
    },
  };

  return <Plot data={data} layout={layout} />;
};

export default ChartComponent;
